import { render, staticRenderFns } from "./FormattingDateUsingExternalLibs.vue?vue&type=template&id=4d3a6f49&"
import script from "./FormattingDateUsingExternalLibs.vue?vue&type=script&lang=js&"
export * from "./FormattingDateUsingExternalLibs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports